import { render, staticRenderFns } from "./asesorcobranza.vue?vue&type=template&id=aa354ec2"
import script from "./asesorcobranza.vue?vue&type=script&lang=js"
export * from "./asesorcobranza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports